module.exports = __webpack_public_path__ + "img/zheda.jpg.a27c9dc9.webp";